import { Component, Input, OnInit, Output, EventEmitter, OnChanges } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { TenantDto } from '@careapp-group/ng-sdk';

export interface TenantsTableData extends TenantDto {
  /**
   * Where to route to if the user clicks on the tenants
   */
  link?: {
    routerLink: string | any[];
    queryParams?: {
      [k: string]: any;
    };
  };
}
@Component({
    selector: 'tenants-table',
    templateUrl: './tenants-table.component.html',
    styleUrls: ['./tenants-table.component.scss'],
    standalone: false
})
export class TenantsTableComponent implements OnInit {
  /**
   * The list of tenants to show in the table
   */
  @Input() tenants: Array<TenantsTableData>;

  /**
   * Whether to allow selection of tenant. If true,
   * a selection checkbox is added at the start of each row,
   * as well as a select all checkbox.
   */
  @Input()
  set allowSelection(value: boolean) {
    if (value) {
      this._displayedColumns = ['selection', ...this._columns];
    } else {
      this._displayedColumns = this._columns;
    }
    this._allowSelection = value;
  }

  /**
   * The columns to display in the table. Possible options:
   *
   *  - name
   *  - number
   *  - address
   */
  @Input()
  set columns(value: Array<string>) {
    if (value) {
      this._displayedColumns = ['selection', ...value];
    } else {
      this._displayedColumns = value;
    }
    this._columns = value;
  }

  /**
   * Emits the list of selected tenants
   */
  @Output() currentSelection = new EventEmitter<TenantDto[]>();

  _displayedColumns: Array<string> = ['name', 'actions'];
  _allowSelection = false;
  _columns: Array<string> = ['name', 'actions'];
  _selection = new SelectionModel<TenantDto>(true, []);

  ngOnInit() {
    this._selection.changed.subscribe(() => {
      this.currentSelection.next(this._selection.selected);
    });
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this._selection.selected.length;
    const numRows = this.tenants.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected()
      ? this._selection.clear()
      : this.tenants.forEach((row) => this._selection.select(row));
  }
}
